import { PublicInterface } from '@support/types/utility/public-interface';

import { Questionnaire } from './questionnaire';
import { WebChatUserInputTools } from './tools/web-chat-user-input-tools';

export class WebChatQuestionnaire<
  TData extends object,
  TId extends string = string
> extends Questionnaire<TData, PublicInterface<WebChatUserInputTools>, TId> {}
